import Library from './library';

export default Library;
